import MAvatar from './Avavtar.vue';

export default MAvatar;
